import axios from "axios";

import { Token } from "../utils/localStorage.util";

import config from "../config.js";

const apiUploadPlanTrib = axios.create({
  baseURL: config.REACT_APP_HOST_API_PLANEJAMENTO_TRIBUTARIO,
});

apiUploadPlanTrib.interceptors.request.use(
  async (config) => {
    const token = Token.getToken();
    if (token) {
      config.headers.Authorization = token;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "multipart/form-data";
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

apiUploadPlanTrib.interceptors.response.use(
  (response) => {
    return response.data;
  },

  async function (error) {
    if (error?.code === "ERR_NETWORK") {
      console.error("Erro de conexão (ERR_NETWORK):", error);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export function uploadArquivosCliente(idCliente, formData) {
  return apiUploadPlanTrib.post(`/clientes/${idCliente}/upload`, formData);
}

export function uploadArquivosParceiro(idParceiro, formData) {
  return apiUploadPlanTrib.post(`/parceiros/${idParceiro}/upload`, formData);
}

export function uploadArquivosAssociado(idAssociado, formData) {
  return apiUploadPlanTrib.post(`/associados/${idAssociado}/upload`, formData);
}

export function uploadCorrecaoArquivos(query, formData) {
  return apiUploadPlanTrib.put(`/upload-correcao-arquivos?${query}`, formData);
}

export function corrigirCadastro(formData) {
  return apiUploadPlanTrib.put(`/correcao-campos`, formData);
}

export function cadastroSimplesCliente(formData) {
  return apiUploadPlanTrib.post(`/clientes/simples`, formData);
}

export default apiUploadPlanTrib;
